const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEurope = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "32px",
    viewBox: "0 0 48 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 32,
    style: {
      fill: "rgb(0%,20%,60%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 24 3.554688 L 23.449219 5.246094 L 24.296875 5.519531 Z M 24 3.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 24 3.554688 L 24.550781 5.246094 L 23.703125 5.519531 Z M 24 3.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 25.691406 4.785156 L 23.914062 4.785156 L 23.914062 5.671875 Z M 25.691406 4.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 25.691406 4.785156 L 24.253906 5.828125 L 23.730469 5.109375 Z M 25.691406 4.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 25.046875 6.773438 L 24.496094 5.082031 L 23.648438 5.355469 Z M 25.046875 6.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 25.046875 6.773438 L 23.605469 5.726562 L 24.128906 5.007812 Z M 25.046875 6.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 22.308594 4.785156 L 24.085938 4.785156 L 24.085938 5.671875 Z M 22.308594 4.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 22.308594 4.785156 L 23.746094 5.828125 L 24.269531 5.109375 Z M 22.308594 4.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 22.953125 6.773438 L 23.503906 5.082031 L 24.351562 5.355469 Z M 22.953125 6.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 22.953125 6.773438 L 24.394531 5.726562 L 23.871094 5.007812 Z M 22.953125 6.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 24 24.890625 L 23.449219 26.578125 L 24.296875 26.855469 Z M 24 24.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 24 24.890625 L 24.550781 26.578125 L 23.703125 26.855469 Z M 24 24.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 25.691406 26.117188 L 23.914062 26.117188 L 23.914062 27.007812 Z M 25.691406 26.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 25.691406 26.117188 L 24.253906 27.164062 L 23.730469 26.441406 Z M 25.691406 26.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 25.046875 28.105469 L 24.496094 26.414062 L 23.648438 26.6875 Z M 25.046875 28.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 25.046875 28.105469 L 23.605469 27.058594 L 24.128906 26.339844 Z M 25.046875 28.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 22.308594 26.117188 L 24.085938 26.117188 L 24.085938 27.007812 Z M 22.308594 26.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 22.308594 26.117188 L 23.746094 27.164062 L 24.269531 26.441406 Z M 22.308594 26.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 22.953125 28.105469 L 23.503906 26.414062 L 24.351562 26.6875 Z M 22.953125 28.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 22.953125 28.105469 L 24.394531 27.058594 L 23.871094 26.339844 Z M 22.953125 28.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 13.332031 14.222656 L 12.785156 15.914062 L 13.628906 16.1875 Z M 13.332031 14.222656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 13.332031 14.222656 L 13.882812 15.914062 L 13.039062 16.1875 Z M 13.332031 14.222656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 15.023438 15.449219 L 13.246094 15.449219 L 13.246094 16.339844 Z M 15.023438 15.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 15.023438 15.449219 L 13.585938 16.496094 L 13.0625 15.777344 Z M 15.023438 15.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 14.378906 17.4375 L 13.828125 15.746094 L 12.984375 16.023438 Z M 14.378906 17.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 14.378906 17.4375 L 12.941406 16.394531 L 13.460938 15.675781 Z M 14.378906 17.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 11.640625 15.449219 L 13.421875 15.449219 L 13.421875 16.339844 Z M 11.640625 15.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 11.640625 15.449219 L 13.082031 16.496094 L 13.601562 15.777344 Z M 11.640625 15.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 12.289062 17.4375 L 12.835938 15.746094 L 13.683594 16.023438 Z M 12.289062 17.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 12.289062 17.4375 L 13.726562 16.394531 L 13.203125 15.675781 Z M 12.289062 17.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 17.621094 8.199219 L 19.058594 7.15625 L 18.539062 6.4375 Z M 17.621094 8.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 17.621094 8.199219 L 18.171875 6.511719 L 19.015625 6.785156 Z M 17.621094 8.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 16.976562 6.214844 L 18.414062 7.257812 L 18.9375 6.539062 Z M 16.976562 6.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 16.976562 6.214844 L 18.753906 6.214844 L 18.753906 7.101562 Z M 16.976562 6.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 18.667969 4.984375 L 18.117188 6.675781 L 18.960938 6.949219 Z M 18.667969 4.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 18.667969 4.984375 L 19.214844 6.675781 L 18.371094 6.949219 Z M 18.667969 4.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 19.710938 8.199219 L 18.273438 7.15625 L 18.796875 6.4375 Z M 19.710938 8.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 19.710938 8.199219 L 19.164062 6.511719 L 18.316406 6.785156 Z M 19.710938 8.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 20.359375 6.214844 L 18.917969 7.257812 L 18.398438 6.539062 Z M 20.359375 6.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 20.359375 6.214844 L 18.578125 6.214844 L 18.578125 7.101562 Z M 20.359375 6.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 15.808594 12.105469 L 15.257812 10.414062 L 14.414062 10.6875 Z M 15.808594 12.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 15.808594 12.105469 L 14.367188 11.058594 L 14.890625 10.339844 Z M 15.808594 12.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 13.71875 12.105469 L 15.15625 11.058594 L 14.632812 10.339844 Z M 13.71875 12.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 13.71875 12.105469 L 14.265625 10.414062 L 15.113281 10.6875 Z M 13.71875 12.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 13.070312 10.117188 L 14.511719 11.164062 L 15.03125 10.441406 Z M 13.070312 10.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 13.070312 10.117188 L 14.847656 10.117188 L 14.847656 11.007812 Z M 13.070312 10.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 16.453125 10.117188 L 15.015625 11.164062 L 14.492188 10.441406 Z M 16.453125 10.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 16.453125 10.117188 L 14.675781 10.117188 L 14.675781 11.007812 Z M 16.453125 10.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 14.761719 8.890625 L 15.3125 10.578125 L 14.464844 10.855469 Z M 14.761719 8.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 14.761719 8.890625 L 14.214844 10.578125 L 15.058594 10.855469 Z M 14.761719 8.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 16.453125 20.785156 L 14.675781 20.785156 L 14.675781 21.671875 Z M 16.453125 20.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 16.453125 20.785156 L 15.015625 21.828125 L 14.492188 21.109375 Z M 16.453125 20.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 15.808594 22.773438 L 15.257812 21.082031 L 14.414062 21.355469 Z M 15.808594 22.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 15.808594 22.773438 L 14.367188 21.726562 L 14.890625 21.007812 Z M 15.808594 22.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 13.71875 22.773438 L 15.15625 21.726562 L 14.632812 21.007812 Z M 13.71875 22.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 13.71875 22.773438 L 14.265625 21.082031 L 15.113281 21.355469 Z M 13.71875 22.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 14.761719 19.554688 L 15.3125 21.246094 L 14.464844 21.519531 Z M 14.761719 19.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 14.761719 19.554688 L 14.214844 21.246094 L 15.058594 21.519531 Z M 14.761719 19.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 13.070312 20.785156 L 14.847656 20.785156 L 14.847656 21.671875 Z M 13.070312 20.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 13.070312 20.785156 L 14.511719 21.828125 L 15.03125 21.109375 Z M 13.070312 20.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 20.359375 24.6875 L 18.578125 24.6875 L 18.578125 25.578125 Z M 20.359375 24.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 20.359375 24.6875 L 18.917969 25.734375 L 18.398438 25.015625 Z M 20.359375 24.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 19.710938 26.675781 L 19.164062 24.984375 L 18.316406 25.261719 Z M 19.710938 26.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 19.710938 26.675781 L 18.273438 25.632812 L 18.796875 24.910156 Z M 19.710938 26.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 17.621094 26.675781 L 19.058594 25.632812 L 18.539062 24.910156 Z M 17.621094 26.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 17.621094 26.675781 L 18.171875 24.984375 L 19.015625 25.261719 Z M 17.621094 26.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 18.667969 23.460938 L 19.214844 25.152344 L 18.371094 25.425781 Z M 18.667969 23.460938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 18.667969 23.460938 L 18.117188 25.152344 L 18.960938 25.425781 Z M 18.667969 23.460938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 16.976562 24.6875 L 18.753906 24.6875 L 18.753906 25.578125 Z M 16.976562 24.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 16.976562 24.6875 L 18.414062 25.734375 L 18.9375 25.015625 Z M 16.976562 24.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 34.667969 14.222656 L 35.214844 15.914062 L 34.371094 16.1875 Z M 34.667969 14.222656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 34.667969 14.222656 L 34.117188 15.914062 L 34.960938 16.1875 Z M 34.667969 14.222656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 32.976562 15.449219 L 34.753906 15.449219 L 34.753906 16.339844 Z M 32.976562 15.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 32.976562 15.449219 L 34.414062 16.496094 L 34.9375 15.777344 Z M 32.976562 15.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 33.621094 17.4375 L 34.171875 15.746094 L 35.015625 16.023438 Z M 33.621094 17.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 33.621094 17.4375 L 35.058594 16.394531 L 34.539062 15.675781 Z M 33.621094 17.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 36.359375 15.449219 L 34.578125 15.449219 L 34.578125 16.339844 Z M 36.359375 15.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 36.359375 15.449219 L 34.917969 16.496094 L 34.398438 15.777344 Z M 36.359375 15.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 35.710938 17.4375 L 35.164062 15.746094 L 34.316406 16.023438 Z M 35.710938 17.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 35.710938 17.4375 L 34.273438 16.394531 L 34.796875 15.675781 Z M 35.710938 17.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 30.378906 8.199219 L 28.941406 7.15625 L 29.460938 6.4375 Z M 30.378906 8.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 30.378906 8.199219 L 29.828125 6.511719 L 28.984375 6.785156 Z M 30.378906 8.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 31.023438 6.214844 L 29.585938 7.257812 L 29.0625 6.539062 Z M 31.023438 6.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 31.023438 6.214844 L 29.246094 6.214844 L 29.246094 7.101562 Z M 31.023438 6.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 29.332031 4.984375 L 29.882812 6.675781 L 29.039062 6.949219 Z M 29.332031 4.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 29.332031 4.984375 L 28.785156 6.675781 L 29.628906 6.949219 Z M 29.332031 4.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 28.289062 8.199219 L 29.726562 7.15625 L 29.203125 6.4375 Z M 28.289062 8.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 28.289062 8.199219 L 28.835938 6.511719 L 29.683594 6.785156 Z M 28.289062 8.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 27.640625 6.214844 L 29.082031 7.257812 L 29.601562 6.539062 Z M 27.640625 6.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 27.640625 6.214844 L 29.421875 6.214844 L 29.421875 7.101562 Z M 27.640625 6.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 32.191406 12.105469 L 32.742188 10.414062 L 33.585938 10.6875 Z M 32.191406 12.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 32.191406 12.105469 L 33.632812 11.058594 L 33.109375 10.339844 Z M 32.191406 12.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 34.28125 12.105469 L 32.84375 11.058594 L 33.367188 10.339844 Z M 34.28125 12.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 34.28125 12.105469 L 33.734375 10.414062 L 32.886719 10.6875 Z M 34.28125 12.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 34.929688 10.117188 L 33.488281 11.164062 L 32.96875 10.441406 Z M 34.929688 10.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 34.929688 10.117188 L 33.152344 10.117188 L 33.152344 11.007812 Z M 34.929688 10.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 31.546875 10.117188 L 32.984375 11.164062 L 33.507812 10.441406 Z M 31.546875 10.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 31.546875 10.117188 L 33.324219 10.117188 L 33.324219 11.007812 Z M 31.546875 10.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 33.238281 8.890625 L 32.6875 10.578125 L 33.535156 10.855469 Z M 33.238281 8.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 33.238281 8.890625 L 33.785156 10.578125 L 32.941406 10.855469 Z M 33.238281 8.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 31.546875 20.785156 L 33.324219 20.785156 L 33.324219 21.671875 Z M 31.546875 20.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 31.546875 20.785156 L 32.984375 21.828125 L 33.507812 21.109375 Z M 31.546875 20.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 32.191406 22.773438 L 32.742188 21.082031 L 33.585938 21.355469 Z M 32.191406 22.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 32.191406 22.773438 L 33.632812 21.726562 L 33.109375 21.007812 Z M 32.191406 22.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 34.28125 22.773438 L 32.84375 21.726562 L 33.367188 21.007812 Z M 34.28125 22.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 34.28125 22.773438 L 33.734375 21.082031 L 32.886719 21.355469 Z M 34.28125 22.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 33.238281 19.554688 L 32.6875 21.246094 L 33.535156 21.519531 Z M 33.238281 19.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 33.238281 19.554688 L 33.785156 21.246094 L 32.941406 21.519531 Z M 33.238281 19.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 34.929688 20.785156 L 33.152344 20.785156 L 33.152344 21.671875 Z M 34.929688 20.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 34.929688 20.785156 L 33.488281 21.828125 L 32.96875 21.109375 Z M 34.929688 20.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 27.640625 24.6875 L 29.421875 24.6875 L 29.421875 25.578125 Z M 27.640625 24.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 27.640625 24.6875 L 29.082031 25.734375 L 29.601562 25.015625 Z M 27.640625 24.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 28.289062 26.675781 L 28.835938 24.984375 L 29.683594 25.261719 Z M 28.289062 26.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 28.289062 26.675781 L 29.726562 25.632812 L 29.203125 24.910156 Z M 28.289062 26.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 30.378906 26.675781 L 28.941406 25.632812 L 29.460938 24.910156 Z M 30.378906 26.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 30.378906 26.675781 L 29.828125 24.984375 L 28.984375 25.261719 Z M 30.378906 26.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 29.332031 23.460938 L 28.785156 25.152344 L 29.628906 25.425781 Z M 29.332031 23.460938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 29.332031 23.460938 L 29.882812 25.152344 L 29.039062 25.425781 Z M 29.332031 23.460938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 31.023438 24.6875 L 29.246094 24.6875 L 29.246094 25.578125 Z M 31.023438 24.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 31.023438 24.6875 L 29.585938 25.734375 L 29.0625 25.015625 Z M 31.023438 24.6875 "
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEurope, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/europe.8713eae7.svg";
export { ForwardRef as ReactComponent };